import React from 'react';
import {Helmet} from 'react-helmet-async';
import {t} from '@lingui/core/macro';

import BlankLayout from 'shared/ui/BlankLayout/BlankLayout';
import NotFoundPage from 'shared/ui/ErrorPage/NotFoundPage';
import Box from 'shared/ui/Box/Box';
import Button from 'shared/ui/Button/Button/Button';

import useNotificationsUnsubscribe from '../../model/useNotificationsUnsubscribe';

import styles from './NotificationsUnsubscribeScreen.module.scss';

const NotificationsUnsubscribeScreen: React.FC = () => {
    const {
        isNotFound, isLoading, isUnsubscribed, email, monitorUrl, unsubscribeMonitor, unsubscribeAll,
    } = useNotificationsUnsubscribe();

    if (isNotFound) {
        return <NotFoundPage/>;
    }

    if (isUnsubscribed) {
        return (<BlankLayout isLoading={false}>
            <Helmet>
                <meta name="robots" content="noindex" />
                <title>{t`Уведомления отключены`}</title>
            </Helmet>
            <div className={styles.wrapper}>
                <div className={styles.box_wrapper}>
                    <Box>
                        <div className="row text-center mb-3">
                            <div className="col-12">
                                <p>{t`Уведомления отключены`}.</p>
                            </div>
                        </div>
                    </Box>
                </div>
            </div>
        </BlankLayout>);
    }

    return (
        <BlankLayout pageTitle={t`Отписаться от уведомлений`} isLoading={isLoading}>
            <Helmet>
                <meta name="robots" content="noindex" />
                <title>{t`Отписаться от уведомлений`}</title>
            </Helmet>

            <div className={styles.wrapper}>
                <div className={styles.box_wrapper}>
                    <Box>
                        <div className="row text-center mb-3">
                            <div className="col-12">
                                <h3>{t`Отключение уведомлений`}</h3>
                                <p className={styles.text}>
                                    <span>
                                        {/* eslint-disable-next-line max-len */}
                                        {t`На этой странице вы можете отписаться от уведомлений сервиса overseer для адреса`}
                                        <b>{email}</b>
                                    </span>
                                    <hr/>
                                    <span className={styles.url}><b>{t`Монитор`}</b>: {monitorUrl}</span>
                                    <br/>
                                    <Button
                                        onClick={unsubscribeMonitor}
                                        title={monitorUrl}
                                    >
                                        {t`Отписаться от уведомлений по монитору`}
                                    </Button>
                                    <hr/>
                                    <Button onClick={unsubscribeAll}>
                                        {t`Отписаться от всех уведомлений`}
                                    </Button>
                                </p>
                            </div>
                        </div>
                    </Box>
                </div>
            </div>
        </BlankLayout>
    );
};

export default NotificationsUnsubscribeScreen;
